import React from 'react';
import type { FieldToolbarNoActionProps } from '../../../types.tsx';
import FieldToolbarOverlay from '../field-toolbar-overlay/view.tsx';

export const FieldToolbarNoAction = ({
	fieldCreator,
	issueTypeName,
	intl: { formatMessage },
	messages,
	isAppField,
}: FieldToolbarNoActionProps) => {
	const descriptionMessage = isAppField
		? messages.noActionFieldToolbarDescriptionAppField
		: messages.noActionFieldToolbarDescription;
	return (
		<FieldToolbarOverlay
			dropHighlight={false}
			header={formatMessage(messages.noActionFieldToolbarHeader)}
			description={formatMessage(descriptionMessage, {
				fieldCreator,
				issueTypeName,
			})}
		/>
	);
};
